<template>
  <div class="content-table">
    <div class="content-row" style="margin-bottom:0">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/HomePage/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/Agreement/index' }">优惠合同</el-breadcrumb-item>
        <el-breadcrumb-item>合同详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content-row" style="margin-top: 3%;">
      <div class="col-4">
        <div class="col-3">特价编号:</div>
        <div class="col-9">
          <el-input v-model="info.agreement_code" :disabled="true"></el-input>
        </div>
      </div>
      <div class="col-4">
        <div class="col-3">优惠码:</div>
        <div class="col-9">
          <el-input v-model="info.agreement_code" :disabled="true"></el-input>
        </div>
      </div>
      <div class="col-4">
        <div class="col-3">项目名称:</div>
        <div class="col-9">
          <el-input v-model="info.project_name" :disabled="true"></el-input>
        </div>
      </div>
    </div>
    <div class="content-row" style="margin-bottom: 2%;">
      <div class="col-4">
        <div class="col-3">联系人:</div>
        <div class="col-9">
          <el-input v-model="info.contact" :disabled="true"></el-input>
        </div>
      </div>
      <div class="col-4">
        <div class="col-3">收货地址:</div>
        <div class="col-9">
          <el-input v-model="info.address" :disabled="true"></el-input>
        </div>
      </div>
    </div>
    <template>
      <el-table
        :data="data"
        :header-cell-style="rowStyle"
        class="content-row table_scroll"
        fixed
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column prop="good_code" border label="商品代码"></el-table-column>
        <el-table-column prop="good_name" border label="商品名称"></el-table-column>
        <el-table-column prop="begin_time" border label="生效日期"></el-table-column>
        <el-table-column prop="end_time" border label="失效日期"></el-table-column>
        <el-table-column prop="max_count" border label="最大数量"></el-table-column>
        <el-table-column prop="special_price" border label="价格"></el-table-column>
        <el-table-column prop="explain" border label="备注"></el-table-column>
      </el-table>
    </template>
    <div class="content-row" style="margin-bottom: 2%;">
      <el-button type="primary" @click="return_index">返回</el-button>
    </div>
  </div>
</template>
<script>
var total_row = [];
export default {
  name: "",
  components: {},

  data() {
    return {
      data: [],
      rowStyle: {
        color: "#fff",
        background: "#52a6ee"
      },
      total: 0,
      pagesize: 10,
      detailes: "",
      row: [],
      sums: "0.00",
      discount: "",
      info: ""
    };
  },
  mounted() {
    this.view();
  },
  watch: {
    currentPage(oldV, newV) {
      
    },
    page: "view",
    pagesize: "view"
  },
  methods: {
    view() {
      var id = this.$route.query.id;
      this.$axios({
        method: "post",
        url: "/index/contract/detail",
        params: {
          id: id
        }
      })
        .then(res => {
          this.data = res.data.data.goods;
          this.info = res.data.data.info;
          
        })
        .catch(err => {
          this.$message(err);
        });
    },
    return_index() {
      this.$router.push({
        path: "/Agreement/index"
      });
    }
  }
};
</script>
<style lang="less" scoped>
.col-3 {
  line-height: 44px;
  padding-right: 1%;
  width: 23.999%;
  font-size: 14px;
}
.col-9 {
  // margin: 5px
}
.discount {
  width: 55%;
}
.table_scroll ::-webkit-scrollbar {
  width: 0px; /*滚动条宽度*/
  height: 5px; /*滚动条高度*/
  background-color: white;
  margin-right: 10px;
}

/*定义滑块 内阴影+圆角*/
.table_scroll ::-webkit-scrollbar-thumb {
  -webkit-box-shadow: inset 0 0 6px #f5f7fa;
  background-color: rgba(221, 222, 224); /*滚动条的背景颜色*/
}
.el-table__fixed-right-patch {
  width: 0px; /*滚动条宽度*/
}
</style>
<style lang="less">
.el-input.is-disabled .el-input__inner {
  background-color: #fff;
  color: #606266;
}
</style>



// WEBPACK FOOTER //
// src/components/Contract/detaile.vue